export default __webpack_public_path__ + "static/media/hht1_song_12.eb7b72c9.png";